import React from 'react';
import PropTypes from 'prop-types';
import './backgroundInfo.css';
import IconCloudDone from 'material-ui/svg-icons/file/cloud-done';
import IconCloudUpload from 'material-ui/svg-icons/file/cloud-upload';
import IconCloud from 'material-ui/svg-icons/file/cloud';

const propTypes = {
    text: PropTypes.string,
    status: PropTypes.string
};

class BackgroundLoadInfo extends React.Component {
    
    componentWillMount() {
        this.setState({
            status: this.props.status,
            text: this.props.text
        })
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            status: nextProps.status,
            text: nextProps.text
        })
    }
    
    render() {
        const className = `cloud-wrapper is_${this.state.status}`;
        return (
            <div className={className}>
                <div className='cloud--icon'>
                    {this.state.status === 'normal' &&
                        <IconCloud color='#fff'/>
                    }
                    {this.state.status === 'error' &&
                    <IconCloudUpload color='#fff'/>
                    }
                    {this.state.status === 'upload' &&
                    <IconCloudUpload color='#fff'/>
                    }
                    {this.state.status === 'done' &&
                    <IconCloudDone color='#fff'/>
                    }
                </div>
                {this.state.text &&
                    <div className='cloud--text'>{this.state.text}</div>
                }
            </div>
        )
    }
}

BackgroundLoadInfo.propsTypes = propTypes;
BackgroundLoadInfo.defaultProps = {
    status: 'normal',
    text: ''
};

export default BackgroundLoadInfo;


// WEBPACK FOOTER //
// src/components/media/BackgroundLoadInfo.js